import * as React from "react";
import { useMemo } from "react";
import { useTranslations } from "../../i18n/useTranslations";
import { isBrowser } from "../../utils";
import { SearchList } from "../SearchList";

export function SearchHistory() {
  if (!isBrowser()) return null;

  const { t } = useTranslations();
  let history = [];

  try {
    history = JSON.parse(localStorage.getItem("dd.searchHistory"));
  } catch (e) {
    history = [];
  }

  const recentSearchHistory = history?.slice(0, 5);
  const showHistory = useMemo(() => recentSearchHistory.length > 0, [recentSearchHistory.length]);

  return (
    showHistory && (
      <div className="elm-py-5 md:elm-p-5 md:elm-pt-0">
        <div
          role="heading"
          className="elm-text-dd-gray-900 elm-font-sans elm-text-sm elm-font-normal elm-uppercase elm-mt-2 elm-mb-1 md:elm-mt-0  md:elm-border-0 md:elm-border-t md:elm-border-solid elm-border-dd-gray-300 md:elm-pt-6"
        >
          {t("History")}
        </div>
        <SearchList searchItems={recentSearchHistory} listType="history" />
      </div>
    )
  );
}
